
import React, { useEffect } from 'react';
import styles from './_scoring-evaluator.module.scss';
import {
  PerformanceIndicatorEvaluationEditorData, PerformanceIndicatorScoreEditor,
  StockBarItemDisplay,
  performanceIndicatorEvaluatorDefaultValues
} from '@amsanalytics/react-shared-library';
import { useDispatch, useSelector } from 'react-redux';
import { get, update } from 'lodash';
import { AppState } from '../../../../store/rootReducer';
import { getPerformanceEvaluation } from '../../../../store/application/actions';
import { Button } from '@progress/kendo-react-buttons';
import localforage from "localforage";
// import '@progress/kendo-theme-default/dist/default-main-dark.scss';

export default function ScoringEvaluator() {
  const dispatch = useDispatch();
  const scoreEditorPerformanceIndicatorEvaluations = useSelector((state: AppState) => state.applications.scoreEditorPerformanceIndicatorEvaluations);
  const [itemValues, setItemValues] = React.useState<PerformanceIndicatorEvaluationEditorData[]>(scoreEditorPerformanceIndicatorEvaluations.length > 0
    ? scoreEditorPerformanceIndicatorEvaluations.map(item => {
      return {
        name: item.name,
        displayName: item.displayName,
        totalGoodLoansInRange: item.totalGoodLoansInRange,
        totalLoansInRange: item.totalLoansInRange,
        minValue: item.minValue,
        maxValue: item.maxValue,
        percentOfLoansInGoodStanding: item.totalLoansInRange > 0
          ? Math.round(item.totalGoodLoansInRange / item.totalLoansInRange * 100)
          : 0,
        totalLoanPoolWithData: item.totalLoanPoolWithData,
        totalAppPoolWithData: item.totalAppPoolWithData,
        useWhenCalculatingScore: true,
      } as PerformanceIndicatorEvaluationEditorData;
    })
    : performanceIndicatorEvaluatorDefaultValues.map(item => {
      return { ...item, totalLoanPoolWithData: 0, totalAppPoolWithData: 0 }
    }));

  useEffect(() => {
    let items = [...itemValues];
    const updateItemValues = async () => {
      const scoringIndicators: string[] | null | undefined = await localforage.getItem('scoringIndicators');
      const scoringWeights: {itemName: string, itemWeight: number}[] | null | undefined  = await localforage.getItem('scoringWeights');
      if (scoringIndicators) {
        items = items.map(itemValue => {
          return {
            ...itemValue,
            useWhenCalculatingScore: scoringIndicators.includes(itemValue.name)
          }
        });
      }
      if (scoringWeights) {
        items = items.map(itemValue => {
          const weight = scoringWeights.find((item: any) => item.itemName === itemValue.name);
          return {
            ...itemValue,
            weight: weight?.itemWeight
          }
        });        
      }
      setItemValues(items);
    };
    updateItemValues();
    // localforage.getItem('scoringIndicators').then((selectedIndicators: any) => {
    //   if (selectedIndicators) {
    //     items = items.map(itemValue => {
    //       return {
    //         ...itemValue,
    //         useWhenCalculatingScore: selectedIndicators.includes(itemValue.name)
    //       }
    //     });
    //     // setItemValues(updatedItemValues);
    //   }
    //   localforage.getItem('scoringWeights').then((selectedWeights: any) => {
    //     if (selectedWeights) {
    //       items = items.map(itemValue => {
    //         const weight = selectedWeights.find((item: any) => item.itemName === itemValue.name);
    //         return {
    //           ...itemValue,
    //           weight: weight?.itemWeight
    //         }
    //       });        
    //     }
    //   });
    // });    
    // setItemValues(items);
  }, []);


  useEffect(() => {
    if (scoreEditorPerformanceIndicatorEvaluations.length > 0) {
      setItemValues(itemValues.map(itemValue => {
        const performanceIndicatorEvaluation = scoreEditorPerformanceIndicatorEvaluations.find(item => item.name?.toLowerCase() === itemValue.name?.toLowerCase());
        if (performanceIndicatorEvaluation) {
          return {
            ...itemValue,
            totalGoodLoansInRange: performanceIndicatorEvaluation.totalGoodLoansInRange,
            totalLoansInRange: performanceIndicatorEvaluation.totalLoansInRange,
            minValue: performanceIndicatorEvaluation.minValue,
            maxValue: performanceIndicatorEvaluation.maxValue,
            percentOfLoansInGoodStanding: performanceIndicatorEvaluation.totalLoansInRange > 0
              ? Math.round((performanceIndicatorEvaluation.totalGoodLoansInRange / performanceIndicatorEvaluation.totalLoansInRange) * 100)
              : 0,
            totalLoanPoolWithData: performanceIndicatorEvaluation.totalLoanPoolWithData,
            totalAppPoolWithData: performanceIndicatorEvaluation.totalAppPoolWithData,
          }
        }
        return itemValue;
      }));
    }
  }, [scoreEditorPerformanceIndicatorEvaluations]);
  const totalEvaluation = scoreEditorPerformanceIndicatorEvaluations.find(itemValue => itemValue.name === 'Total');
  let totalEvaluationOfLoansInGoodStanding: number | null = null;
  if (totalEvaluation) {
    const totalLoansInRange = scoreEditorPerformanceIndicatorEvaluations
      .filter(aac => itemValues.filter(iv => iv.useWhenCalculatingScore).map(iv => iv.name).includes(aac.name) === true).reduce((acc, item) => acc + item.totalLoansInRange, 0);
    const totalGoodLoansInRange = scoreEditorPerformanceIndicatorEvaluations
      .filter(aac => itemValues.filter(iv => iv.useWhenCalculatingScore).map(iv => iv.name).includes(aac.name) === true).reduce((acc, item) => acc + item.totalGoodLoansInRange, 0);
    
    totalEvaluationOfLoansInGoodStanding = totalLoansInRange > 0
      ? Math.round((totalGoodLoansInRange / totalLoansInRange) * 100)
      : 0;
  }

  return (
    <div className={styles.scoringEvaluatorContainer}>
      <PerformanceIndicatorScoreEditor
        performanceIndicatorEditorValues={itemValues}
        onChange={(values) => setItemValues(values)}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {totalEvaluationOfLoansInGoodStanding && (
            <div style={{ marginLeft: '15px', display: 'flex', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Percentage of loans in good standing for all indicators: </span>
              <div style={{ width: '200px' }}><StockBarItemDisplay percentile={totalEvaluationOfLoansInGoodStanding} rank={totalEvaluationOfLoansInGoodStanding > 55 ? 'Good' : totalEvaluationOfLoansInGoodStanding > 45 ? 'Acceptable' : 'Bad'} /></div>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
          <Button themeColor='success' style={{ display: 'flex', width: '200px', marginTop: '20px', marginRight: '20px', color: 'white' }}
            onClick={async () => {
              // save useWhenCalculatingScore for each item to local storage using local forage
              await localforage.setItem('scoringIndicators', itemValues.filter(itemValue => itemValue.useWhenCalculatingScore).map(itemValue => itemValue.name));
              await localforage.setItem('scoringWeights', itemValues.filter(itemValue => itemValue.useWhenCalculatingScore).map(itemValue => {return {itemName: itemValue.name, itemWeight: itemValue.weight}}));
            }}
          >
            Save Settings
          </Button>
          <Button themeColor='primary' style={{ display: 'flex', alignSelf: 'flex-end', width: '200px', marginTop: '20px', marginRight: '20px' }}
            onClick={() => dispatch(getPerformanceEvaluation({
                bureauScore: Math.round(get(itemValues.find(itemValue => itemValue.name === 'BureauScore')!, 'value')),
                jobTimeInMonths: Math.round(get(itemValues.find(itemValue => itemValue.name === 'JobTimeInMonths')!, 'value')),
                residenceTimeInMonths: Math.round(get(itemValues.find(itemValue => itemValue.name === 'ResidenceTimeInMonths')!, 'value')),
                income: Math.round(get(itemValues.find(itemValue => itemValue.name === 'Income')!, 'value')),
                paymentToIncome: Math.round(get(itemValues.find(itemValue => itemValue.name === 'PaymentToIncome')!, 'value')),
                numThirtyDays: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumThirtyDays')!, 'value')),
                numSixtyDays: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumSixtyDays')!, 'value')),
                numNinetyDays: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumNinetyDays')!, 'value')),
                currentTradeLines: Math.round(get(itemValues.find(itemValue => itemValue.name === 'CurrentTradeLines')!, 'value')),
                tradeLinesCB: Math.round(get(itemValues.find(itemValue => itemValue.name === 'TradeLinesCB')!, 'value')),
                numAccountsPaid: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumAccountsPaid')!, 'value')),
                numAutosPaid: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumAutosPaid')!, 'value')),
                numHistoricallyNegative: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumHistoricallyNegative')!, 'value')),
                numBankruptcy: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumBankruptcy')!, 'value')),
                numActiveBankruptcy: Math.round(get(itemValues.find(itemValue => itemValue.name === 'NumActiveBankruptcy')!, 'value')),
              }))
            }>
            Evaluate
          </Button>
        </div>

      </div>
    </div>
  );
}
